import { parseRequestError } from '@/app/common/utilities'
import { useToast } from '@/shad/ui/toast/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { paymentApprovalApi } from '../api'
import { paymentApprovalKeys } from '../keys'

type Props = {
  programId: number
  onSuccess: () => void
}

export function useBulkUpdateRuleStatus({ programId, onSuccess }: Props) {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation({
    mutationFn: async ({
      ruleIds,
      isActive,
    }: {
      ruleIds: number[]
      isActive: boolean
    }) => {
      return await paymentApprovalApi.bulkUpdateRuleStatus(
        ruleIds,
        isActive,
        programId
      )
    },
    onSuccess: () => {
      toast({
        title: 'Rules Updated',
        description: `Successfully Updated rule(s).`,
      })

      // Invalidate all payment approval rules queries to refetch fresh data
      queryClient.invalidateQueries({
        queryKey: [paymentApprovalKeys.allRules()[0]],
      })
      onSuccess()
    },
    onError: (error) => {
      const newError = parseRequestError(error)
      toast({
        title: 'Error',
        description:
          newError.message || 'There was an error updating the rules.',
        variant: 'destructive',
      })
    },
  })
}
